<div class="chat-actions">
  <textarea rows="4" class="chat-actions__input" [formControl]="message" nz-input></textarea>
  <div class="chat-actions__actions">
    <!--<ui-icon nameIcon="attach_file"></ui-icon>-->
    <!--<ui-icon-btn nameIcon="send"></ui-icon-btn>-->
    <span></span>
    <!--<a (click)="attach()">Прикрепить файлы</a>-->
    <ui-button (click)="send()">Отправить</ui-button>
  </div>
</div>
